import { useId } from 'react'
import { Field, Input, Label, ValidationMessage } from '@digdir/designsystemet-react'

type CheckboxProps = {
  id?: string
  checked: boolean
  onChange: (next: boolean) => void
  indeterminate?: boolean
  label?: string
  hideLabel?: boolean
  hint?: string
  error?: string
  disabled?: boolean
  required?: boolean
}

export function Checkbox({ id, checked, onChange, indeterminate = false, label, hideLabel = false, hint, error, disabled, required }: CheckboxProps) {
  const baseId = useId()
  const checkboxId = id ?? `${baseId}checkbox`

  return (
    <Field className="cb-field" onClick={event => event.stopPropagation()}>
      <Input
        id={checkboxId}
        className="cb"
        type="checkbox"
        checked={checked}
        data-indeterminate={indeterminate && !checked}
        disabled={disabled}
        required={required}
        aria-invalid={error ? 'true' : undefined}
        onChange={event => { if (!disabled) onChange(event.target.checked) }}
      />
      {label && <Label htmlFor={checkboxId} className={hideLabel ? 'cb-field__label ds-sr-only' : 'cb-field__label'} weight="regular">{label}</Label>}
      {hint && <Field.Description id={`${checkboxId}-hint`} className="field__hint">{hint}</Field.Description>}
      {error && <ValidationMessage id={`${checkboxId}-err`} className="field__err" role="alert">{error}</ValidationMessage>}
    </Field>
  )
}
